var path = '/assets/js/dashboard/company/create/create.html';
var html = "<h1>\n    {{'models.company.action.create' | translate }}\n</h1>\n<company-form company=\"$ctrl.company\" busy=\"$ctrl.busy\" save-fn=\"$ctrl.save(company)\"></company-form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;